<template>
  <div class="page-productCollection">
    <Navigation
      :title="`商品收藏${collectionListData.total_count > 0 ? ` (${collectionListData.total_count})` : ''}`"
      :optionText="collectionListData.total_count > 0 ? (isEdit ? '完成' : '编辑') : ''"
      optionStyle="color: #232321;"
      @option="handleClickOption"
    />
    <!-- 骨架屏 -->
    <div class="skeleton-list" v-if="showCollectionListSkeleton">
      <md-skeleton class="skeleton-item" v-for="item in 5" :key="item" avatar title :row="2" :loading="showCollectionListSkeleton"></md-skeleton>
    </div>
    <!-- 收藏的商品列表 -->
    <div class="collection-list-wrap" v-show="collectionListData.total_count > 0">
      <md-scroll-view ref="scrollView" :scrolling-x="false" @refreshing="onPullingDownRefresh" @end-reached="onPullingUp">
        <md-scroll-view-refresh
          slot="refresh"
          slot-scope="{ scrollTop, isRefreshActive, isRefreshing }"
          :scroll-top="scrollTop"
          :is-refreshing="isRefreshing"
          :is-refresh-active="isRefreshActive"
        ></md-scroll-view-refresh>
        <div class="collection-list">
          <SingleGoodsItem
            :isEdit="isEdit"
            :key="`${collectionItem.goodsId}_${index}`"
            v-for="(collectionItem, index) in collectionListData.data"
            :item="collectionItem"
            @select="handleSelectOne(collectionItem)"
          />
        </div>
        <md-scroll-view-more slot="more" :is-finished="!showCollectionListSkeleton && !collectionListData.loadMore"></md-scroll-view-more>
      </md-scroll-view>
    </div>
    <div class="nav-bar" v-show="isEdit">
      <div class="select-wrap" @click="handleClickSelectAll()">
        <img class="icon-select" :src="isSelectedAll ? selectedIcon : unSelectIcon" />
        <span>全选</span>
      </div>
      <span class="btn-remove" @click="handleClickRemove()">移除商品</span>
    </div>
    <md-result-page
      style="margin-top:-2rem;"
      type="empty"
      text="还没有收藏的商品~"
      v-show="!showCollectionListSkeleton && !collectionListData.loadMore && collectionListData.total_count === 0"
    ></md-result-page>
  </div>
</template>

<script>
import Navigation from '@/components/navigation'
import SingleGoodsItem from '@/components/singleGoodsItem'
import { Dialog, ScrollView, ScrollViewRefresh, ScrollViewMore, ResultPage, Skeleton } from 'mand-mobile'
import { getPageData } from '@/utils/help'
const collectionItem = {
  buyPrice: 15.9,
  picUrl: 'https://img.alicdn.com/tfscom/i1/3878483432/O1CN010k8ogo1bDtqcgBvj2_!!0-item_pic.jpg',
  marketPrice: 69,
  couponAmount: 1,
  sharePrice: 0.25,
  salesVolume: 2074,
  goodsId: 595997323214,
  goldenBeans: 12,
  couponClickUrl:
    'https://uland.taobao.com/coupon/edetail?e=TQCZ%2F1LizvgGQASttHIRqR8uJzmpFax8YqXW9vejEUYzTAsPwf4oeG4TeH65VXVLYyeCZ6oHhM8dlEDK%2F3jf%2B5%2BNsQz1ZeJFRv%2B8NlZ1Yr1Sje14g2G3LCVwYEZYh9cwBY2mYYKU440Zao0HO%2FvX0w%3D%3D&union_lens=lensId:0b1af702_527e_16e7c6fdb99_beb9',
  buyUrl:
    'https://s.click.taobao.com/t?e=m%3D2%26s%3DYIZj5aWyc%2BQcQipKwQzePOeEDrYVVa64yK8Cckff7TXjf2vlNIV67kpmBELP4V2%2BAMg8lLLxypo2OVLkyDHzy8w07B0o2CWYX9Tv%2FeLmLA9OeIUbE8ba4v0jCkSDmD6DKe3%2FbelnU7chre9gvq5P3zKYVV1BId1rfp5HoTJX0vVZW9O6z%2FdQD0LgtoCmJMxz3930lyqI4HbYgduoWnJ1SJx1Q4Hkt9oSipYw3UORxig5hDCuE8TSLA%3D%3D&union_lens=lensId:0b1af702_527e_16e7c6fdb99_beb9',
  source: '天猫',
  title: '长袖t恤女打底衫春秋装韩版学生宽松ins潮闺蜜装慵懒风中长款上衣',
}
export default {
  name: 'orders',
  components: {
    Navigation,
    SingleGoodsItem,
    [Dialog.name]: Dialog,
    [Skeleton.name]: Skeleton,
    [ResultPage.name]: ResultPage,
    [ScrollView.name]: ScrollView,
    [ScrollViewRefresh.name]: ScrollViewRefresh,
    [ScrollViewMore.name]: ScrollViewMore,
  },
  data() {
    return {
      selectedIcon: require('../../assets/images/icon_selected.png'),
      unSelectIcon: require('../../assets/images/icon_unselect.png'),
      isEdit: false, // 是否编辑
      isSelectedAll: false, // 是否全选
      showCollectionListSkeleton: true,
      collectionListData: {
        currentPage: 1,
        pageSize: 20,
        total_count: 0,
        loadMore: true,
        data: [],
      },
    }
  },
  created() {
    this.initData()
  },
  methods: {
    initData() {
      this.fetchCollectionList(1)
    },
    /**
     * 下拉刷新
     */
    onPullingDownRefresh() {
      this.isEdit = false
      this.isSelectedAll = false
      this.fetchCollectionList(1, true)
    },
    /**
     * 加载更多
     */
    onPullingUp() {
      if (this.collectionListData.loadMore) {
        this.fetchCollectionList(this.collectionListData.currentPage + 1)
      }
    },
    /**
     * 收藏的商品列表
     */
    fetchCollectionList(currentPage, isPullingDownRefresh) {
      if (currentPage === 1) {
        this.showCollectionListSkeleton = true
      }
      this.$http
        .tbk.markedProductList(currentPage)
        .then(res => {
          this.collectionListData = getPageData(currentPage, this.collectionListData, res)
          for (let item of this.collectionListData.data) {
            this.$set(item, 'isSelected', false)
          }
          if (isPullingDownRefresh || currentPage === 1) {
            // 下拉刷新
            this.$refs.scrollView.finishRefresh()
            this.$refs.scrollView.finishLoadMore() // 重置加载更多
          }
          if (currentPage > 1) {
            // 加载更多
            this.$refs.scrollView.finishLoadMore()
          }
          this.showCollectionListSkeleton = false
          this.$nextTick(() => {
            this.$refs.scrollView.reflowScroller()
          })
        })
        .catch(() => {
          this.showCollectionListSkeleton = false
        })
    },
    /**
     * 点击操作
     */
    handleClickOption() {
      this.isEdit = !this.isEdit
      if (!this.isEdit) {
        this.isSelectedAll = false
        for (let item of this.collectionListData.data) {
          item.isSelected = false
        }
      }
    },
    /**
     * 全选/全不选
     */
    handleClickSelectAll() {
      this.isSelectedAll = !this.isSelectedAll
      for (let item of this.collectionListData.data) {
        item.isSelected = this.isSelectedAll
      }
    },
    /**
     * 选择/取消选择 一个
     */
    handleSelectOne(item) {
      item.isSelected = !item.isSelected
      let isSelectedAll = true // 全部商品的选中状态
      for (let item of this.collectionListData.data) {
        if (!item.isSelected) {
          isSelectedAll = false
          break
        }
      }
      this.isSelectedAll = isSelectedAll
    },
    /**
     * 移除收藏
     */
    handleClickRemove() {
      Dialog.confirm({
        title: '提示',
        content: '此操作将移除选中的商品, 是否继续?',
        confirmText: '确定',
        onConfirm: () => {
          // 取出所要删除的id列表
          let ids = ''
          for (let item of this.collectionListData.data) {
            if (item.isSelected) ids += ids.length === 0 ? item.goodsId : `|${item.goodsId}`
          }
          // 批量移除收藏的商品
          this.$http.tbk.unmarkProductByIds(ids).then(success => {
            this.isEdit = false
            this.isSelectedAll = false
            this.fetchCollectionList(1)
          })
        },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.page-productCollection {
  position: relative;
  height: 100%;
  background: #fff;
  .skeleton-list {
    background: #fff;
    padding: 0.4rem;
  }
  .collection-list-wrap {
    position: absolute;
    top: 0.88rem;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 1;
    background-color: #f8f8f8;
    .collection-list {
      border-top: 0.02rem solid #eeefef;
      padding: 0;
    }
  }
  .nav-bar {
    position: fixed;
    z-index: 900;
    bottom: 0;
    left: 0;
    right: 0;
    background: hsla(0, 0%, 100%, 0.8);
    height: 1rem;
    line-height: 1rem;
    &:before {
      content: '';
      height: 0;
      display: block;
      border-top: 0.02rem solid #ccc;
      transform: scaleY(0.5);
      transform-origin: 50% 0;
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
    }
    .select-wrap {
      // 全选
      display: flex;
      height: 1rem;
      width: 2rem;
      align-items: center;
      padding-left: 0.24rem;
      &:active {
        opacity: 0.4;
      }
      .icon-select {
        width: 0.4rem;
        height: 0.4rem;
        margin-right: 0.1rem;
      }
    }
    .btn-remove {
      // 移除商品
      display: block;
      position: absolute;
      width: 1.6rem;
      height: 0.5rem;
      line-height: 0.5rem;
      font-size: 0.28rem;
      color: #fff;
      text-align: center;
      border-radius: 0.06rem;
      right: 0.2rem;
      top: 0.25rem;
      background: #e4393c;
      &:active {
        opacity: 0.4;
      }
    }
  }
}
</style>
